<template>
  <div id="modalRegistrationRecommendCompany" class="modal">
    <div class="modal-background"></div>
    <!-- Modal content -->
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h2>Neue Langsamfahrstelle einreichen</h2>
          <span class="close" @click="close">&times;</span>
        </div>
        <div class="modal-body">
          <div class="text-center flex flex-col gap-2 items-center" v-show="status == 2">
            <font-awesome-icon icon="check" class="icon color-success" />
            <p>Vielen Dank!<br>Wir werden Deine Meldung prüfen.</p>
          </div>

          <div class="text-center flex flex-col gap-2 items-center" v-show="status == 1">
            <font-awesome-icon icon="spinner" class="icon" pulse />
            <p></p>
          </div>

          <div class="text-center flex flex-col gap-2" v-show="status == 0">
            <!-- {{data}} -->

            <div class="flex flex-col sm:flex-row gap-1 justify-between mb-4">
              <div class="flex flex-col gap-2 basis-1/2">
                <label>Station A</label>
                <select class="rounded-md text-center w-full py-1 text-black" @change="checkInputs" v-model="form.station_a">
                <option disabled selected value="-1">-</option>
                <option v-for="station in stations" :key="station.id" :value="station.id">{{station.name}} ({{station.shortname}})</option>
              </select>
              </div>

              <div class="flex flex-col gap-2 basis-1/4">
                <label>Richtung</label>
                <select class="rounded-md text-center w-full py-1 text-black" @change="checkInputs" v-model="form.direction">
                  <option disabled selected value="-1">-</option>
                  <option value="A">&#8594;</option>
                  <option value="B">&#8592;</option>
                  <option value="AB">&#8644;</option>
                </select>
              </div>

              <div class="flex flex-col gap-2 basis-1/2">
                <label>Station B</label>
                <select class="rounded-md text-center w-full py-1 text-black" @change="checkInputs" v-model="form.station_b">
                  <option disabled selected value="-1">-</option>
                  <option v-for="station in stations" :key="station.id" :value="station.id">{{station.name}} ({{station.shortname}})</option>
                </select>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row gap-2 justify-between mb-4">
              <div class="flex flex-col gap-2 justify-end w-full">
                <label>Aktuelle Geschwindigkeit</label>
                <select class="rounded-md text-center p-1 text-black" @change="checkInputs" v-model="form.speedslow">
                <option disabled selected value="-1">-</option>
                <option>5</option>
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
                <option>35</option>
                <option>40</option>
                <option>45</option>
                <option>50</option>
                <option>55</option>
                <option>60</option>
                <option>65</option>
                <option>70</option>
                <option>75</option>
                <option>80</option>
                <option>85</option>
                <option>90</option>
                <option>95</option>
                <option>100</option>
              </select>
              </div>

              <div class="flex flex-col gap-2 w-full">
                <label>Reguläre Geschwindigkeit</label>
                <select class="rounded-md text-center p-1 text-black" @change="checkInputs" v-model="form.speednormal">
                  <option disabled selected value="-1">-</option>
                  <option>5</option>
                  <option>10</option>
                  <option>15</option>
                  <option>20</option>
                  <option>25</option>
                  <option>30</option>
                  <option>35</option>
                  <option>40</option>
                  <option>45</option>
                  <option>50</option>
                  <option>55</option>
                  <option>60</option>
                  <option>65</option>
                  <option>70</option>
                  <option>75</option>
                  <option>80</option>
                  <option>85</option>
                  <option>90</option>
                  <option>95</option>
                  <option>100</option>
                </select>
              </div>
              <!-- <label><input type="se" name="speednormal" value="0" id="" v-model="form.typ" @change="changeTyp"> Reguläre Geschwindigkeit</label> -->
            </div>

            <div class="flex flex-col gap-2 w-full mb-4">
              <label>Grund</label>
              <select class="rounded-md text-center p-1 text-black" @change="checkInputs" v-model="form.reason">
                <option disabled selected value="-1">-</option>
                <option v-for="reason in reasons" :key="reason.id" :value="reason.id">{{reason.text}}</option>
              </select>
            </div>

            <div class="flex flex-col gap-2 w-full mb-4">
              <label>Linien</label>

              <div class="grid grid-cols-3 sm:grid-cols-8 gap-2 w-full">
              <label v-for="line in lines" :key="line.id"><input type="checkbox" :value="line.id" v-model="form.lines" @change="checkInputs"> {{line.name}}</label>
              </div>

              <!-- <br><br>{{form}} -->
            </div>

            <!-- <label><input type="radio" name="reportTyp" value="1" id="" v-model="form.typ" @change="changeTyp"> Aufgehoben</label> -->

            <button
              id="submitDataAddSlowspeed"
              @click="sendAction()"
              class="button-filled text-center btn-fullsize w-full"
              :disabled="stepCompleteDisabled"
            >
              Langsamfahrstelle einreichen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ModalBoardReportCreator",
  data() {
    return {
      show: this.showModal,
      reasons: [],
      stations: [],
      stepCompleteDisabled: true,
      form: {
        speednormal: -1,
        speedslow: -1,
        reason: -1,
        lines: [],
        station_a: -1,
        station_b: -1,
        direction: -1
      },
      status: 0,

      lines: []
    };
  },
  props: {
    image: String,
    showModal: false,
    data: null
  },
  mounted() {
    this.$store.dispatch("fetchSpeedlimitReasons").then((a) => {
      if (a.status == true) {
        this.reasons = a.response
      }
    });

    this.$store.dispatch("fetchStations").then((a) => {
      if (a.status == true) {
        this.stations = a.response
      }
    });

    this.$store.dispatch("fetchLines").then((a) => {
      if (a.status == true) {
        this.lines = a.response
      }
    });
  },
  methods: {
    checkInputs() {
      if(this.form.speednormal != -1 &&
      this.form.speedslow != -1 &&
      this.form.reason != -1 &&
      this.form.station_a != -1 &&
      this.form.station_b != -1 &&
      this.form.direction != -1 &&
      this.form.lines.length > 0) {
        this.stepCompleteDisabled = false
      } else {
        this.stepCompleteDisabled = true
      }
    },
    sendAction() {
      this.status = 1
      
      this.$store.dispatch("createSpeedlimitReport", this.form).then((a) => {
        if (a.status == true) {
          this.status = 2
        }
      });
    },
    close() {
      this.form = {
        speednormal: -1,
        speedslow: -1,
        reason: -1,
        lines: [],
        station_a: -1,
        station_b: -1,
        direction: -1
      }
      this.status = 0
      this.$emit("close");
    },
  }
};
</script>




